import React from "react";
import {
	CalendarOutlined,
	LineChartOutlined,
	UserDeleteOutlined,
} from "@ant-design/icons";
import ClientActivity from "./client-activity";
import StoppedOrdering from "./stopped-ordering";
import WithoutOrders from "./without-orders";

/** URL path segment for a report — `/client-reports/{key}`. */
export type ClientReportKey =
	| "stopped-ordering"
	| "without-orders"
	| "client-activity";

export interface ReportDefinition {
	key: ClientReportKey;
	/** Key inside the `reports` localization sub-namespace. */
	stringsKey: string;
	fallbackLabel: string;
	fallbackDescription: string;
	/** The question this report answers, so the two list reports cannot be confused. */
	fallbackQuestion: string;
	icon: React.ReactNode;
	component: React.ReactNode;
}

/**
 * Adding a report = one entry here + one block of localization strings in all three locale files.
 *
 * Unlike Bulk Order Operations there is no per-country config module: these are read-only reports
 * that behave identically against all three databases, with no driver ids, zone ids or money
 * movement to configure. Access is the Admin role alone — see AdminRoute.tsx.
 */
export const REPORTS: ReportDefinition[] = [
	{
		key: "stopped-ordering",
		stringsKey: "stoppedOrdering",
		fallbackLabel: "Klientë që kanë ndaluar porositë",
		fallbackDescription:
			"Klientët që nuk kanë sjellë më porosi — listë për t'i kontaktuar",
		fallbackQuestion: "Kush na la, dhe që kur?",
		icon: <UserDeleteOutlined />,
		component: <StoppedOrdering />,
	},
	{
		key: "without-orders",
		stringsKey: "withoutOrders",
		fallbackLabel: "Klientë pa porosi në periudhë",
		fallbackDescription:
			"Klientët që nuk kanë regjistruar asnjë porosi mes dy datave",
		fallbackQuestion: "Kush nuk solli asgjë brenda kësaj periudhe?",
		icon: <CalendarOutlined />,
		component: <WithoutOrders />,
	},
	{
		key: "client-activity",
		stringsKey: "clientActivity",
		fallbackLabel: "Aktiviteti i një klienti",
		fallbackDescription:
			"Për një klient: ditët me porosi kundrejt ditëve pa porosi",
		fallbackQuestion: "Sa aktiv ka qenë ky klient?",
		icon: <LineChartOutlined />,
		component: <ClientActivity />,
	},
];

export const findReport = (
	key: string | undefined
): ReportDefinition | undefined => REPORTS.find((report) => report.key === key);
